import {Component, OnInit} from '@angular/core';
import {AuthService, ParserService, BlockAbstractComponent, PageService} from '@gallaghercp/core-frontend';
import {BreakpointObserver} from '@angular/cdk/layout';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpClient} from '@angular/common/http';

@Component({
    standalone: false,
    selector: 'core-feedback',
    templateUrl: './block-feedback.component.html',
})
export class BlockFeedbackComponent extends BlockAbstractComponent implements OnInit {

    formActive!: boolean;
    feedbackSucceeded?: boolean;
    feedbackFailed?: boolean;
    feedbackClicked?: boolean;
    submissionData?: { decisionId: number, meta: { subject: string, page: string, WasThisPageHelpful?: string, message?: string } };

    feedbackForm = new FormGroup({
            feedback: new FormControl('', [Validators.required, Validators.minLength(3)]),
            feedback__confirm: new FormControl(''),
        }
    );

    sentiment?: boolean | null;
    submitting!: boolean;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected override pages: PageService,
        protected breakpoint: BreakpointObserver,
        protected http: HttpClient
    ) {
        super(
            parser,
            auth,
            pages,
        );
    }

    hasPositiveSentiment() {
        return this.sentiment === true;
    }

    hasNegativeSentiment() {
        return this.sentiment === false;
    }

    isSubmitting(sentiment: boolean) {
        return this.submitting && this.sentiment === sentiment;
    }

    submitFeedback(sentiment: boolean | null | undefined) {
        if (this.feedbackForm.get('feedback__confirm')?.value) {
            return false;
        }

        this.sentiment = sentiment;
        this.submitting = true;

        this.submissionData = {
            decisionId: 1,
            meta: {
                subject: 'Feedback Form Submission',
                page: this.pages.getCurrentPage().name,
            }
        };

        switch (sentiment) {
            case true:
                this.submissionData.meta.WasThisPageHelpful = 'yes';
                this.submissionData.meta.message = this.feedbackForm.get('feedback')?.value ?? undefined;
                break;
            case false:
                this.submissionData.meta.WasThisPageHelpful = 'no';
                this.submissionData.meta.message = this.feedbackForm.get('feedback')?.value ?? undefined;
                break;
        }

        return this.http.post('open-submission', this.submissionData).subscribe(response => {
            this.submitting = false;
            this.formActive = false;
            this.feedbackSucceeded = true;
        }, () => {
            this.submitting = false;
            this.sentiment = null;
            this.feedbackFailed = true;
        });

    }

    override ngOnInit() {
        super.ngOnInit();
        this.resetForm();
    }

    resetForm() {
        this.sentiment = null;
        this.formActive = true;
        this.feedbackSucceeded = false;
        this.feedbackFailed = false;
        this.feedbackClicked = false;
    }

}
